import { render, staticRenderFns } from "./AccessError.vue?vue&type=template&id=629d47b7&scoped=true&"
import script from "./AccessError.vue?vue&type=script&lang=js&"
export * from "./AccessError.vue?vue&type=script&lang=js&"
import style0 from "./AccessError.vue?vue&type=style&index=0&id=629d47b7&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629d47b7",
  null
  
)

export default component.exports